/// <reference path="appconstants.ts" />
var EnvNgApp;
(function (EnvNgApp) {
    var Constants;
    (function (Constants) {
        var AppEvents;
        (function (AppEvents) {
            // "translatedDataChanged" fires up only if new translations were loaded
            // (eg. opening new view do load some new translations)
            AppEvents.translatedDataChanged = "$translatedDataChanged";
            // "translatedDataStartedLoading" fires up every time when view file contains "JavaScriptHelper.AddResourcesToEnvNgApp" to load translations
            AppEvents.translatedDataStartedLoading = "$translatedDataStartedLoading";
            // "translatedDataFinishedLoading" fires up always after all translations were loaded 
            // (eg. opening the same view multiple times does not load any new translations but always fire "translatedDataFinishedLoading" event)
            AppEvents.translatedDataFinishedLoading = "$translatedDataFinishedLoading";
        })(AppEvents = Constants.AppEvents || (Constants.AppEvents = {}));
    })(Constants = EnvNgApp.Constants || (EnvNgApp.Constants = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=AppEvents.js.map